module.exports = __webpack_public_path__ + "img/CDNX-start_spinner.32cf96.svg";